import React from 'react';
import {Image, View, StyleSheet} from 'react-native';
import Text from '@basicComponents/text';
import theme from '@/style';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import {goTo} from '@/utils';
import {currentBrand} from '@/brands';
import LinearGradient from '@/components/basic/linear-gradient';

const logoImg = require('@/assets/anna/logos/logo-96.png');
const freeLotteryImg = require('@/assets/anna/game/freelottery.webp');
const searchImg = require('@/assets/icons/home/search.png');

const SearchEntry = () => {
  return (
    <NativeTouchableOpacity
      onPress={() => goTo('search')}
      style={styles.search}>
      <Image source={searchImg} style={styles.searchIcon} />
    </NativeTouchableOpacity>
  );
};

const LoginButton = () => {
  return (
    <NativeTouchableOpacity
      onPress={() => goTo('Login')}
      style={styles.loginButton}>
      <Text color={theme.basicColor.primary} fontSize={12} blod>
        LOGIN
      </Text>
    </NativeTouchableOpacity>
  );
};

const AnnaHomeHeader = ({
  login,
  onPressLottery,
  isDownloadBannerVisible,
}: {
  login: boolean;
  onPressLottery: () => void;
  isDownloadBannerVisible: boolean;
}) => {
  return (
    <View
      style={[
        theme.flex.row,
        theme.flex.between,
        theme.flex.centerByCol,
        styles.wrap,
      ]}>
      <LinearGradient
        colors={['#F9B871', '#F11402']}
        style={[
          styles.headerBg,
          isDownloadBannerVisible ? styles.headerBgTall : styles.headerBgShort,
        ]}
      />
      <View style={[theme.flex.row, theme.flex.centerByCol, styles.leftWrap]}>
        <Image source={logoImg} style={styles.logo} />
        <Text
          color={theme.basicColor.white}
          fontSize={16}
          blod
          style={styles.brandName}>
          {currentBrand.appName}
        </Text>
      </View>
      <View style={[theme.flex.row, theme.flex.centerByCol, styles.rightWrap]}>
        {login ? (
          <NativeTouchableOpacity
            onPress={onPressLottery}
            style={styles.freeEntry}>
            <Image
              source={freeLotteryImg}
              style={styles.freeLottery}
              resizeMode="contain"
            />
          </NativeTouchableOpacity>
        ) : (
          <LoginButton />
        )}
        <SearchEntry />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    height: 44,
    paddingHorizontal: 12,
    position: 'relative',
    overflow: 'hidden',
    zIndex: 10,
  },
  headerBg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
  headerBgTall: {
    height: 208,
  },
  headerBgShort: {
    height: 160,
  },
  leftWrap: {
    zIndex: 1,
  },
  rightWrap: {
    zIndex: 1,
    gap: 4,
  },
  logo: {
    width: 28,
    height: 28,
    borderRadius: 8,
    marginRight: 12,
  },
  brandName: {
    fontWeight: '700',
  },
  loginButton: {
    width: 81,
    height: 31,
    borderRadius: 999,
    backgroundColor: theme.basicColor.white,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
    boxShadow: 'inset 0px 1.5px 0px 0px #FFCCC7',
  },
  freeEntry: {
    marginRight: 4,
  },
  freeLottery: {
    width: 108,
    height: 32,
  },
  search: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
});

export default AnnaHomeHeader;
